export default __webpack_public_path__ + "static/dark-d89b0378c6556ef855f6cfc504b9bd78.png";